import { css } from 'styled-components';
import { media } from '../../../../helpers/mixins';
import { PURPLE_LIGHT, WHITE } from '../../../../constants/colors';

/**
 * getColor
 * @param {string} status - button status
 * @returns {string}
 */
const getColor = (status) => {
  switch (status) {
    case 'valid':
      return 'green';
    case 'error':
      return 'red';
    case 'normal': {
      return PURPLE_LIGHT;
    }
    default:
      return WHITE;
  }
};

export default {
  buttonWrapper: ({ status, width, height, disabled, textColor }) => css`
    display: flex;
    ${!(status === 'disabled' || status === 'valid')
      && css`
        cursor: pointer;
      `}
    justify-content: center;
    align-items: center;
    // border: 1px solid ;
    height: ${height || '38px'};
    width: ${width || 'auto'};
    border-radius: 0.25rem;
    color:  ${getColor(status)};
    color: ${textColor || WHITE};
    background-color: #ff3094;
    padding-inline: 35px;
  `,

  icon:() => css`
    margin: 0px 10px 0px -10px;
  `,

  buttonContainer: ({ status, style }) => css`
    // margin: auto;
    // top: 43.5%;
    // position: absolute;
    // margin-left: 0px;
    // padding-left: 45%;

    ${media.sm`
      // right: 20%;
      // top: 44%;
      // margin-inline: auto;
     `};
  `,

  styledSpinner:({ props}) => css`
    display: inline-block;
    position: relative;
    width: ${props => props.size}px;
    height: ${props => props.size}px;

    div {
      box-sizing: border-box;
      display: block;
      position: absolute;
      width: ${props => props.size}px;
      height: ${props => props.size}px;
      border: ${props => props.size / 8}px solid;
      border-radius: 50%;
      animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
      border-color: ${props => props.color} transparent transparent transparent;
    }

    div:nth-child(1) {
      animation-delay: -0.45s;
    }

    div:nth-child(2) {
      animation-delay: -0.3s;
    }

    div:nth-child(3) {
      animation-delay: -0.15s;
    }

    @keyframes lds-ring {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  `  
};
